export default class Common {
    constructor() {
        this.svg_ratio = 685 / 1300;
        this.$win = $(window);
        this.$visual_svg = $('.visual-svg');
        this.$visual_svg_wrap = $('.visual-svg-wrap');
        this.$visual_image = $('.visual-image');

        this.fadetime = 1000;
        this.slidetime = 2000;
    }
    toppage_slide() {
        const _self = this;
        let img_array = _self.get_slideimage_url();
        let slide_html = '';
        img_array = img_array.reverse();
        img_array.forEach(function(arr) {
            slide_html += `<div class="slide-ie" style="background-image: url(${arr});"><img src="${arr}"></div>`;
        });
        let slides = $('<div class="slide-ies">' + slide_html + '</div>');
        _self.$visual_svg.prepend(slides);

        slides.ready(function() {
            slides.imagesLoaded()
            .done(function(instance) {
                $('.visual-svg').addClass('show');
                slide();
            });
        });

        function slide() {
            $('.slide-ies').find('.slide-ie:last').delay(_self.slidetime).fadeTo(_self.fadetime, 0, function() {
                let $active = $(this);
                $active.remove();
                $('.slide-ies').prepend($active.css('opacity', 1));
                slide();
            });
        }
    }

    get_slideimage_url() {
        const _self = this;
        let img_array = [];
        _self.$visual_image.find('img').each(function() {
            img_array.push($(this).attr('src'));
        });
        return img_array;
    }
    toppage_svg_slide() {
        const _self = this;
        let img_array = _self.get_slideimage_url();

        _self.$visual_svg.append(_self.append_svg(img_array));

        _self.$svg_slide = $('#svg-slide');
        _self.$item = $('#svg-slide').find('.slide-item');
        _self.$image_wrap = $('#svg-slide').find('.slide-image');
        _self.$rect = $('#svg-slide').find('.rect');
        _self.$clip = $('#clip');
        _self.$clip_bg = $('#clip-bg');

        _self.$visual_image.imagesLoaded()
        .done(function(instance) {
            _self.$rect.attr('width', 1300);
            _self.$rect.attr('height', 685);
            _self.$item.attr('width', 1300);
            _self.$item.attr('height', 685);
            let items = [];
            _self.$item.each(function() {
                items.push($(this));
            });

            _self.$image_wrap.empty();
            items = items.reverse();
            items.forEach(function(item) {
                _self.$image_wrap.append(item);
            });

            if (items.length > 1) {
                setTimeout(function() {
                    $('.visual-svg').addClass('show');
                    $('.visual-svg-wrap').find('.loading').addClass('hide');
                    slide();
                }, 1500);
            } else {
                $('.visual-svg').addClass('show');
                $('.visual-svg-wrap').find('.loading').addClass('hide');
            }

            function slide() {
                _self.$image_wrap.find('image:last').delay(_self.slidetime).fadeTo(_self.fadetime, 0, function() {
                    let $active = $(this);
                    $active.remove();
                    _self.$image_wrap.prepend($active.css('opacity', 1));
                    slide();
                });
            }
            $(window).on('load resize', function() {
                let widths = _self.$win.width() - 30;
                if (window.matchMedia('(max-width:768px)').matches) {
                    _self.$svg_slide.width(widths);
                    _self.$svg_slide.height(widths * _self.svg_ratio);
                    _self.$visual_svg.width(widths);
                    _self.$visual_svg.height(widths * _self.svg_ratio);
                    _self.$visual_svg_wrap.width(widths);
                    _self.$visual_svg_wrap.height(widths * _self.svg_ratio);
                } else {
                    _self.$svg_slide.width(1300);
                    _self.$svg_slide.height(685);
                    _self.$visual_svg.width(1300);
                    _self.$visual_svg.height(685);
                    _self.$visual_svg_wrap.width(1300);
                    _self.$visual_svg_wrap.height(685);
                }
            });
        });
    }

    append_svg(array) {
        let image_html = '';
        array.forEach(function(arr) {
            image_html += `<image class="slide-item" xlink:href="${arr}"></image>`;
        });
        const svg = `
        <svg id="svg-slide" viewBox="0 0 1300 685">
            <clipPath id="clip-bg">
                <path>
                    <animate dur="10s" repeatCount="indefinite" attributeName="d" attributeType="XML" values="M776.9,672.4c-19.3,0.7-38.7,0.6-58.1-0.8c-81.1-6-160.7,16.4-242.1,13.1c-82.1-3.3-159.3-16.3-241.3-16.2
                    c-69.9,0.1-159.1-18.2-193.1-91.8c-20.4-44.2-13.5-95.1-11.1-142.5C34,377.7-0.6,321.2,0,264.7c0.6-55.5,27.2-117,51.2-168.6
                    c32-68.7,111.1-75.5,175-68.3c45.7,5.2,91.5,9.4,137.3,12.7c100.1,7.2,200.8-34.4,300.8-40c101.4-5.7,202.9,38.4,304.4,35.7
                    c48.7-1.3,97.6-5.1,146.2-5.4c58.7-0.3,123.6,20.1,143.4,85.2c15.6,51.5,8.7,112.1,4.3,165.1c-4.8,57.3,36.4,114.7,37.4,172.3
                    c1.3,72.3-39.7,154.2-116.7,192.7c-63,31.5-120.1,16.6-186,13C923.5,655.2,850.4,669.6,776.9,672.4z;M785.1,684.5c-20.3,0.8-40.5,0.7-60.9-0.8c-85.1-6.3-168.5-28.3-253.9-31.8c-86-3.5-167,28.4-253,28.5
                    c-73.3,0.1-166.8-19.3-202.4-97.2C-6.6,536.4,0.8,482.5,3.2,432.4C6.2,372.7,6,312.9,6.7,253.1C7.4,194.3-1,129.3,24.2,74.6
                    C57.7,1.9,140.7-5.2,207.7,2.4c47.9,5.5,95.9,9.9,144,13.4c105,7.6,210.5,11.7,315.4,5.8c106.3-6,212.7-7.5,319.1-10.3
                    c51-1.4,102.4-5.4,153.3-5.7c61.5-0.4,129.6,21.3,150.4,90.2c16.4,54.5,9.1,118.7,4.5,174.7c-5,60.7-12.5,121.3-11.4,182.4
                    c1.3,76.6,9,163.2-71.8,204c-66.1,33.3-125.9,17.5-195,13.8C938.8,666.4,862.2,681.6,785.1,684.5z;M780,684.5c-20.1,0.8-40.3,0.7-60.5-0.8c-84.5-6.4-191.1-13.7-275.9-17.2c-85.5-3.5-215.6,7-301.1,7
                    c-72.8,0.1-104.3-24.1-128.2-79.3C-6.2,546.9,0.6,481.8,3.1,431.6c2.9-59.9,15.2-97.3,15.2-166.5c0-59-30-145.9-5-200.7
                    C46.6-8.6,114.7-3.5,181.2,4.2c47.6,5.5,127.1,14.6,174.9,18.1c104.3,7.6,235.6-6.1,339.8-12c105.6-6,143.7,18.9,249.4,16.1
                    c50.7-1.4,110.3-17.8,161-18.1c61.1-0.4,131.2,39.1,157,86.3c27.4,50,40.4,122.4,35.8,178.6c-5,60.9-9,116.4-7.9,177.6
                    c1.3,76.8-7.2,149.8-87.4,190.7c-65.6,33.4-125.4,32.9-194.1,29.1C932.7,666.3,856.6,681.6,780,684.5z;M776.9,672.4c-19.3,0.7-38.7,0.6-58.1-0.8c-81.1-6-160.7,16.4-242.1,13.1c-82.1-3.3-159.3-16.3-241.3-16.2
                    c-69.9,0.1-159.1-18.2-193.1-91.8c-20.4-44.2-13.5-95.1-11.1-142.5C34,377.7-0.6,321.2,0,264.7c0.6-55.5,27.2-117,51.2-168.6
                    c32-68.7,111.1-75.5,175-68.3c45.7,5.2,91.5,9.4,137.3,12.7c100.1,7.2,200.8-34.4,300.8-40c101.4-5.7,202.9,38.4,304.4,35.7
                    c48.7-1.3,97.6-5.1,146.2-5.4c58.7-0.3,123.6,20.1,143.4,85.2c15.6,51.5,8.7,112.1,4.3,165.1c-4.8,57.3,36.4,114.7,37.4,172.3
                    c1.3,72.3-39.7,154.2-116.7,192.7c-63,31.5-120.1,16.6-186,13C923.5,655.2,850.4,669.6,776.9,672.4z;">
                    </animate>
                </path>
            </clipPath>
            <g>
                <rect class="rect" clip-path="url(#clip-bg)" fill="#d2c98e">
            </g>
            <clipPath id="clip">
                <path>
                    <animate dur="10s" repeatCount="indefinite" attributeName="d" attributeType="XML" values="M520,0.5c20.1-0.8,40.3-0.7,60.5,0.8C665.1,7.7,771.7,15,856.5,18.5c85.5,3.5,215.6-7,301.1-7
                    c72.8-0.1,104.3,24.1,128.2,79.3c20.5,47.3,13.7,112.4,11.2,162.6c-2.9,59.9-15.2,97.3-15.2,166.5c0,59,30,145.9,5,200.7
                    c-33.3,73-101.4,67.9-167.9,60.2c-47.6-5.5-127.1-14.6-174.9-18.1c-104.3-7.6-235.6,6.1-339.8,12c-105.6,6-143.7-18.9-249.4-16.1
                    c-50.7,1.4-110.3,17.8-161,18.1c-61.1,0.4-131.2-39.1-157-86.3C9.3,540.5-3.7,468.1,0.9,411.9c5-60.9,9-116.4,7.9-177.6
                    C7.6,157.5,16.1,84.5,96.3,43.6c65.6-33.4,125.4-32.9,194.1-29.1C367.3,18.7,443.4,3.4,520,0.5z;M514.9,0.5c20.3-0.8,40.5-0.7,60.9,0.8c85.1,6.3,168.5,28.3,253.9,31.8c86,3.5,167-28.4,253-28.5
                    c73.3-0.1,166.8,19.3,202.4,97.2c21.4,46.8,14.1,100.7,11.6,150.8c-3,59.7-2.8,119.6-3.5,179.4c-0.7,58.8,7.7,123.8-17.5,178.4
                    c-33.5,72.7-116.5,79.9-183.5,72.2c-47.9-5.5-95.9-9.9-144-13.4c-105-7.6-210.5-11.7-315.4-5.8c-106.3,6-212.7,7.5-319.1,10.3
                    c-51,1.4-102.4,5.4-153.3,5.7C99,679.8,30.9,658.1,10.2,589.2C-6.2,534.7,1,470.6,5.7,414.5c5-60.7,12.5-121.3,11.4-182.4
                    c-1.3-76.6-9-163.2,71.8-204c66.1-33.3,125.9-17.5,195-13.8C361.2,18.6,437.8,3.4,514.9,0.5z;M523.1,12.6c19.3-0.7,38.7-0.6,58.1,0.8c81.1,6,160.7-16.4,242.1-13.1c82.1,3.3,159.3,16.3,241.3,16.2
                    c69.9-0.1,159.1,18.2,193.1,91.8c20.4,44.2,13.5,95.1,11.1,142.5c-2.8,56.4,31.9,113,31.2,169.5c-0.6,55.5-27.2,117-51.2,168.6
                    c-32,68.7-111.1,75.5-175,68.3c-45.7-5.2-91.5-9.4-137.3-12.7c-100.1-7.2-200.8,34.4-300.8,40c-101.4,5.7-202.9-38.4-304.4-35.7
                    c-48.7,1.3-97.6,5.1-146.2,5.4c-58.7,0.3-123.6-20.1-143.4-85.2C26,517.4,33,456.8,37.4,403.9C42.2,346.6,1,289.2,0,231.6
                    C-1.2,159.2,39.7,77.3,116.7,38.8c63-31.5,120.1-16.6,186-13C376.5,29.8,449.6,15.4,523.1,12.6z;M520,0.5c20.1-0.8,40.3-0.7,60.5,0.8C665.1,7.7,771.7,15,856.5,18.5c85.5,3.5,215.6-7,301.1-7
                    c72.8-0.1,104.3,24.1,128.2,79.3c20.5,47.3,13.7,112.4,11.2,162.6c-2.9,59.9-15.2,97.3-15.2,166.5c0,59,30,145.9,5,200.7
                    c-33.3,73-101.4,67.9-167.9,60.2c-47.6-5.5-127.1-14.6-174.9-18.1c-104.3-7.6-235.6,6.1-339.8,12c-105.6,6-143.7-18.9-249.4-16.1
                    c-50.7,1.4-110.3,17.8-161,18.1c-61.1,0.4-131.2-39.1-157-86.3C9.3,540.5-3.7,468.1,0.9,411.9c5-60.9,9-116.4,7.9-177.6
                    C7.6,157.5,16.1,84.5,96.3,43.6c65.6-33.4,125.4-32.9,194.1-29.1C367.3,18.7,443.4,3.4,520,0.5z;">
                </animate>
                </path>
            </clipPath>
            <g class="slide-image" clip-path="url(#clip)">
                ${image_html}
            </g>
        </svg>
        `;
        return svg;
    }

    get_browser() {
        let userAgent = window.navigator.userAgent.toLowerCase();
        return (userAgent.indexOf('msie') >= 0 || userAgent.indexOf('trident') >= 0);
    }
}
